import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, Observable } from 'rxjs';
import { SettingService } from './setting.service';
import { ImageService } from './image.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiControllerService } from './api-controller.service';

export interface IimageLibraryData {
  shortNameReference: string;
  valueImageCollected: string;
}

@Injectable({
  providedIn: 'root',
})
export class NavbarConfigurationService {

  isNavBarImageLoaded: boolean = false;

  get getnavbarImageLoaded(): boolean {
    return this.isNavBarImageLoaded;
  }


  selectedNav: number = 0;
  imageLibrary: IimageLibraryData[] = [];

  get getSelectedNav(): number {
    return this.selectedNav
  }

  set setSelectedNav(index) {
    this.selectedNav = index;
  }

  // only used for extra navbar configuration. For now, it's only the images

  constructor(private http: HttpClient,
    private settingService: SettingService,
    private imageService: ImageService,
    private sanitizer: DomSanitizer,
    private apiController: ApiControllerService
  ) { }

  // complimentary methods
  
  getImage(path: string): Observable<Blob> {
    return Observable.create(o => {
      /* this.http.post(this.settingService.apiUrl('Menu/GetMenuItemImage'), {
        path: path
      }, { responseType: 'blob' })
        .pipe(finalize(() => {
          o.complete();
        }))
        .subscribe(
          result => o.next(result),
          res => {
            if (res.status != 400)
              o.error(res);
          }
        ) */
      this.apiController.post(this.settingService.apiUrl('Menu/GetMenuItemImage'), {
        path: path
      }, { responseType: 'blob' })
        .pipe(finalize(() => {
          o.complete();
        }))
        .subscribe(
          result => o.next(result),
          res => {
            if (res.status != 400)
              o.error(res);
          }
        )
    });
  }

  fetchImage(ImageShortname) {
    return new Promise((resolve, reject) => {
      if (ImageShortname != null && ImageShortname != "") {
        // we'll check if the "preloadImage" has value here
        
        var imageData = this.preloadedImage(ImageShortname);

        if(imageData == "") {
          this.getImage(ImageShortname).subscribe(data => {
            this.imageService.createImageFromBlob(data)
            .pipe(finalize(() => {
                
            }))
            .subscribe(async (buffer) => {
              this.setloadedImage(ImageShortname, buffer);
              resolve(buffer);
            });       
          }, error => {
          });
        } else {
          resolve(imageData);
        }

        
      } else {
        resolve('');
      }
    });
  } 


  /////////////////////////////////////////////////////////////////////////////////
  // icons preload

  setloadedImage(ImageShortname, imageBuffer) {
    var valueReference = {
      shortNameReference: ImageShortname,
      valueImageCollected: imageBuffer
    }

    this.imageLibrary.push(valueReference); 
  }

  preloadedImage(ImageShortname): string {
    const match = this.imageLibrary.find(
      item => item.shortNameReference === ImageShortname
    );


    if(match) {
      return match.valueImageCollected;
    } else {
      return "";
    }
  }

  /////////////////////////////////////////////////////////////////////////////////
}
